export const environment = {
	production: false,
	API_URL: 'https://cms.dev.universitycompare.com/api/',
};
